<script>
import draggable from "vuedraggable";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import bannerSvc from "@/services/banner";
import { toast } from "vue3-toastify";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Manage Banner",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    draggable,
  },
  data() {
    return {
      title: "Manage Banner",
      role:
        localStorage.getItem("userInfo") !== null
          ? JSON.parse(localStorage.getItem("userInfo")).role
          : "user",
      images: [],
      submitted: false,
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      bannerSvc
        .getAll()
        .then((resp) => {
          const data = resp.data.data;
          const banner = data === null ? [] : data;
          this.images = this.setBanner(banner);
        })
        .catch((err) => {
          console.log(err);
          toast.error("data not found", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          this.$router.push("/");
        });
    },
    setBanner(banner) {
      const data = [];
      for (let i = 0; i < 10; i++) {
        if (banner[i]?.uuid) {
          data.push(banner[i]);
        } else {
          data.push({
            uuid: "",
            url: "",
            priority: "",
            redirectUrl: "",
            createdAt: "",
            originName: "",
          });
        }
      }
      return data;
    },
    uploadImage(index) {
      const formData = new FormData();
      let refFile = this.$refs.file0.files;
      if (index === 1) {
        refFile = this.$refs.file1.files;
      } else if (index === 2) {
        refFile = this.$refs.file2.files;
      } else if (index === 3) {
        refFile = this.$refs.file3.files;
      } else if (index === 4) {
        refFile = this.$refs.file4.files;
      } else if (index === 5) {
        refFile = this.$refs.file5.files;
      } else if (index === 6) {
        refFile = this.$refs.file6.files;
      } else if (index === 7) {
        refFile = this.$refs.file7.files;
      } else if (index === 8) {
        refFile = this.$refs.file8.files;
      } else if (index === 9) {
        refFile = this.$refs.file9.files;
      }

      for (const element of refFile) {
        let file = element;
        formData.append("images", file);
      }

      bannerSvc
        .uploadFile(formData)
        .then((resp) => {
          resp.data.data.forEach((image) => {
            this.images[index] = {
              uuid: image.url,
              url: image.url,
              originName: image.originName,
              redirectUrl: this.images[index].redirectUrl,
            };
          });
        })
        .finally(() => {
          if (index === 0) {
            this.$refs.file0.value = "";
          } else if (index === 1) {
            this.$refs.file1.value = "";
          } else if (index === 2) {
            this.$refs.file2.value = "";
          } else if (index === 3) {
            this.$refs.file3.value = "";
          } else if (index === 4) {
            this.$refs.file4.value = "";
          } else if (index === 5) {
            this.$refs.file5.value = "";
          } else if (index === 6) {
            this.$refs.file6.value = "";
          } else if (index === 7) {
            this.$refs.file7.value = "";
          } else if (index === 8) {
            this.$refs.file8.value = "";
          } else {
            this.$refs.file9.value = "";
          }
        });
    },
    handleSubmit() {
      // this.submitted = true;
      // if (this.v$.$invalid) {
      //   return;
      // } else {
      this.submitted = false;

      if (this.submitted) {
        return;
      }

      const images = [];
      let priority = 1;
      Object.keys(this.images).forEach((key) => {
        if (this.images[key]?.uuid !== "") {
          images.push({
            priority: +priority,
            url: this.images[key].url,
            originName: this.images[key].originName,
            redirectUrl: this.images[key].redirectUrl,
          });
          priority++;
        }
      });

      console.log("images", images);

      bannerSvc
        .updateBanner({ images })
        .catch((err) => {
          toast.error(err, {
            autoClose: localStorage.getItem("toastCountdown"),
          });
        })
        .finally(() => {
          this.submitted = false;
          this.get();
          toast.success("Updated Successfully", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
        });

      // }
    },
    deleteImage(index) {
      // this.images.splice(index, true);
      this.images[index] = {
        uuid: "",
        url: "",
        priority: "",
        redirectUrl: "",
        createdAt: "",
        originName: "",
      };
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <form class="needs-validation" @submit.prevent="handleSubmit()">
            <div class="row">
              <div class="col-md-12">
                <draggable v-model="images" item-key="id">
                  <template #item="{ element, index }">
                    <div class="album-drag row">
                      <div class="row">
                        <div class="col-md-10 border-drag">
                          <div class="mb-3 position-relative">
                            <label for="">{{ index + 1 }}</label>
                          </div>
                          <div class="mb-3 position-relative">
                            <div class="h-div-image">
                              <div class="col-md-12 image">
                                <img :alt="element.uuid" :src="element.url" />
                              </div>
                              <div class="col-md-12 btn-delete">
                                <b-button
                                  v-if="element.uuid"
                                  size="sm"
                                  variant="danger"
                                  @click="deleteImage(index)"
                                  >Delete</b-button
                                >
                              </div>
                            </div>
                            <div class="mb-3 position-relative">
                              <label for="">Redirect Url</label>
                              <input
                                v-model="element.redirectUrl"
                                type="text"
                                class="form-control"
                              />
                            </div>
                            <div class="mb-3 position-relative">
                              <label for="">Banner (1,920 X 1,080) </label>
                              <input
                                id="remark"
                                type="file"
                                :ref="`file${index}`"
                                accept="image/x-png,image/gif,image/jpeg"
                                @change="uploadImage(index)"
                                class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
              </div>
            </div>
            <div class="text-sm-end">
              <button class="btn btn-success ms-1" type="submit">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
span.is-required {
  color: red;
}
.border-drag {
  border-style: dashed;
  border-width: 1px;
  border-color: black;
  padding-top: 5px;
}
.h-div-image {
  height: 240px;
}
.album-drag {
  display: inline-flex;
  margin: 10px;
  /* width: 245px !important; */
  width: 30% !important;
  height: 450px !important;
}
.album-drag .image {
  text-align: center;
  height: 210px;
}
.album-drag .btn-delete {
  text-align: center;
  margin-top: 10px;
}
.album-drag img {
  max-width: 100%;
  max-height: 200px;
  height: auto;
  width: auto;
}
div.upload-thumbnail .delete-attachment {
  color: red;
}
.invalid-feedback-custom {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f46a6a;
}

@media (max-width: 600px) {
  .album-drag {
    display: inline-flex;
    width: 245px !important;
    height: 450px !important;
  }
  .h-div-image {
    height: 250px;
  }
  .album-drag img {
    max-width: 200px;
    max-height: 155px;
  }
}
</style>
